export default __webpack_public_path__ + "static/media/MAX 125_5.bfa49154.webp";